import { render, staticRenderFns } from "./DoctorAssistantModal.vue?vue&type=template&id=f3112cee&scoped=true&"
import script from "./DoctorAssistantModal.vue?vue&type=script&lang=js&"
export * from "./DoctorAssistantModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorAssistantModal.vue?vue&type=style&index=0&id=f3112cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3112cee",
  null
  
)

export default component.exports